import { render, staticRenderFns } from "./LayoutFloating.vue?vue&type=template&id=263df2ed&scoped=true"
import script from "./LayoutFloating.vue?vue&type=script&lang=js"
export * from "./LayoutFloating.vue?vue&type=script&lang=js"
import style0 from "./LayoutFloating.vue?vue&type=style&index=0&id=263df2ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263df2ed",
  null
  
)

export default component.exports